// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"pM-z","carouselContainer":"qM-z"};